import { AttributeService } from './../services/attribute/attribute.service';
import { MemberStateModel } from './../members/member.model';
import { State, Selector, Action, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Member } from '../members/member.actions';
import { takeUntil, tap } from 'rxjs/operators';
import { Ticket } from '../ticket-list/state/ticket.actions';
import { MemberService } from '../services/member/member.service';

@State<MemberStateModel>({
  name: 'members',
  defaults: {
    attributes: undefined,
    isLoading: false,
    tags: undefined,
    isPasswordUpdated: false,
    // approvers: undefined
  },
})
@Injectable()
export class MemberState {
  constructor(
    private attributeService: AttributeService,
    private memberService: MemberService
  ) {}

  @Selector()
  public static getAttributes(state: MemberStateModel) {
    return state.attributes;
  }

  @Selector()
  public static getLoadingStatus(state: MemberStateModel) {
    return state.isLoading;
  }

  @Selector()
  public static getPasswordUpdatedStatus(state: MemberStateModel) {
    return state.isPasswordUpdated;
  }

  @Action(Member.Actions.GetAttributes)
  public getRoles(
    { patchState }: StateContext<MemberStateModel>,
    action: Member.Actions.GetAttributes
  ) {
    return this.attributeService
      .getAttributesByOrganization(action.organizationId)
      .pipe(
        tap(
          (attributes) => {
            // console.log('set roles', attributes);

            // attributes = attributes.filter(
            //   (x) => x.category === CustomDataAttributeCategory.Profile
            // );
            patchState({
              isLoading: false,
              attributes: attributes,
            });
          },
          (errorResponse) => {
            // console.log('errorResponse', errorResponse);
            patchState({
              isLoading: false,
            });
          }
        )
      );
  }

  @Action(Member.Actions.SetBulkMemberTags)
  public setBulkMemberTags(
    { patchState }: StateContext<MemberStateModel>,
    action: Member.Actions.SetBulkMemberTags
  ) {
    return this.memberService
      .updateMemberTags(action.memberIds, action.tag)
      .pipe(
        tap(
          (attributes) => {
            // Update the Members Here whose tags are updated.
            patchState({
              isLoading: false,
              // attributes: attributes,
              tags: [], //
            });
          },
          (errorResponse) => {
            // console.log('errorResponse', errorResponse);
            patchState({
              isLoading: false,
            });
          }
        )
      );
  }

  // @Action(Member.Actions.SetTags)
  // setMemberTag(
  //   ctx: StateContext<MemberStateModel>,
  //   action: Ticket.Actions.SetTags
  // ) {
  //   // do later
  //   // this.store.dispatch(new Member.Actions.ScanTicketResetError());

  //   return this.memberService
  //     .updateTags(action.ticketId, action.tags)
  //     .pipe(takeUntil(this.unSubscribeAll$))
  //     .subscribe({
  //       next: (ticket) => {
  //         const state = ctx.getState();

  //         const tickets = [...state.campaignTickets];
  //         const ticketIndex = tickets.findIndex((d) => d.id === ticket.id);

  //         if (ticketIndex >= 0) {
  //           tickets[ticketIndex] = ticket; //return ticketView
  //         }

  //         //scan ticket success message
  //         this.store.dispatch(new Ticket.Actions.ScanTicketSuccess(ticket));
  //         // this.store.dispatch(new Ticket.Actions.ScanTicketError(ticket));
  //         ctx.patchState({
  //           updatedTicketId: ticket.id,
  //           scannedTicket: ticket,
  //           errorMessage: undefined,
  //           items: [...tickets],
  //           campaignTickets: [...tickets],
  //           isLoading: false,
  //           // updatedTicketId: ticket.id,
  //         });
  //       },
  //       error: (err) => {
  //         console.log('scan error message', err);

  //         ctx.patchState({
  //           errorMessage: err?.error?.message,
  //         });

  //         this.store.dispatch(
  //           new Ticket.Actions.ScanTicketError(err?.error?.message)
  //         );
  //       },
  //     });
  // }
}
